"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductSizesOptions = void 0;
const shared_types_1 = require("@merchx-v2/shared-types");
const settings_1 = require("../settings");
const sizesOrder = {
    XS: 1,
    SM: 2,
    MD: 3,
    LG: 4,
    XL: 5,
    '2XL': 6
};
/**
 * Function return all uniq sizes options for a given productId in a list of prices
 * You can use `replacements` argument object to change the sizes labels.
 *
 * @param {object[]} prices - source list of prices
 * @param {string} productId - product ID which prices you want to find
 * @param {Record<string, string>=} replacements - Used to replace the size labels. For example if you will provide the object like:
 * `{
 *  "SM": "S",
 *  "LG": "LARGE"
 * }` - it will replace SM -> S, and LG -> LARGE
 */
const getProductSizesOptions = (prices, productId, replacements = {}) => {
    const productPrices = prices.filter((price) => price.productId === productId);
    const result = {};
    for (const { productType, attributes } of productPrices) {
        if (productType && !settings_1.settings.productTypesSettings[productType]) {
            throw new Error(`@merchx/helpers: Function getProductSizesOptions asd - Unknown product type (${productType})!`);
        }
        if (!productType || settings_1.settings.productTypesSettings[productType].includes(shared_types_1.ATTRIBUTE_TYPE.SIZE)) {
            const sizeAttribute = attributes.find((item) => item.attribute === shared_types_1.ATTRIBUTE_TYPE.SIZE);
            if (!(sizeAttribute === null || sizeAttribute === void 0 ? void 0 : sizeAttribute.value)) {
                throw new Error(`Size was not defined for a product (${productId})!`);
            }
            if (!result[sizeAttribute === null || sizeAttribute === void 0 ? void 0 : sizeAttribute.value]) {
                result[sizeAttribute.value] = {
                    value: sizeAttribute.value,
                    label: replacements[sizeAttribute.value] || (sizeAttribute === null || sizeAttribute === void 0 ? void 0 : sizeAttribute.value)
                };
            }
        }
    }
    return Object.values(result).sort((a, b) => {
        let sortValue = 0;
        if (sizesOrder[a.value] && sizesOrder[b.value]) {
            sortValue = sizesOrder[a.value] - sizesOrder[b.value];
        }
        return sortValue;
    });
};
exports.getProductSizesOptions = getProductSizesOptions;
//# sourceMappingURL=getProductSizesOptions.js.map